<template>
    <div class="row">
        <div :class="isPreviewActive ? 'col-sm-8': 'col-sm'">
            <div class="card-body">
                <form class="default-form" @submit="updateItemSubmit" novalidate>

                    <div class="form-group">
                        <label>Proizvod</label>
                        <b-form-select v-model="selectedItem" :options="items" @change="onItemSelect">
                            <template #first>
                                <b-form-select-option :value="null" disabled>Odaberi proizvod (ID - Naziv)</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>

                    <div class="form-group">
                        <label for="nameInput">Naziv</label>
                        <input id="nameInput" class="form-control" type="text" placeholder="Naziv proizvoda" v-model="name" :disabled="selectedItem === null"/>
                    </div>

                    <div class="form-group">
                        <label for="imageInput">Slika</label>
                        <input id="imageInput" class="form-control" type="text" placeholder="URL do slike proizvoda" v-model="imageUrl" :disabled="selectedItem === null"/>
                    </div>

                    <div class="form-group">
                        <label for="descriptionInput">Opis</label>
                        <textarea id="descriptionInput" class="form-control" placeholder="Opis proizvoda" rows="5" v-model="description" :disabled="selectedItem === null"/>
                    </div>

                    <div class="form-group">
                        <label for="ingredientsInput">Sastojci</label>
                        <textarea id="ingredientsInput" class="form-control" placeholder="Sastojci proizvoda" rows="5" v-model="ingredients" :disabled="selectedItem === null"/>
                    </div>

                    <div class="form-group">
                        <div class="form-row">
                            <div class="col">
                                <label for="widthInput">Duzina (mm)</label>
                                <input id="widthInput" type="number" class="form-control" placeholder="Duzina proizvoda u milimetrima" min="0" v-model="width" :disabled="selectedItem === null">
                            </div>
                            <div class="col">
                                <label for="heightInput">Visina (mm)</label>
                                <input id="heightInput" type="number" class="form-control" placeholder="Visina proizvoda u milimetrima" min="0" v-model="height" :disabled="selectedItem === null">
                            </div>
                            <div class="col">
                                <label for="thicknessInput">Debljina (mm)</label>
                                <input id="thicknessInput" type="number" class="form-control" placeholder="Debljina proizvoda u milimetrima" min="0" v-model="thickness" :disabled="selectedItem === null">
                            </div>
                            <div class="col">
                                <label for="weightInput">Tezina (g)</label>
                                <input id="weightInput" type="number" class="form-control" placeholder="Tezina proizvoda u gramima" min="0" v-model="weight" :disabled="selectedItem === null">
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="form-row">
                            <div class="col">
                                <label for="priceInput">Cena</label>
                                <input id="priceInput" type="number" class="form-control" placeholder="Cena proizvoda" min="0" v-model="price" :disabled="selectedItem === null">
                            </div>
                            <div class="col">
                                <label for="discountInput">Popust</label>
                                <input id="discountInput" type="number" class="form-control" placeholder="Popust na cenu u procentima (0 - 100)" min="0" maxlength="100" v-model="discount" :disabled="selectedItem === null">
                            </div>
                            <div class="col">
                                <label for="amountInput">Kolicina</label>
                                <input id="amountInput" type="number" class="form-control" placeholder="Kolicina proizvoda na stanju" min="0" v-model="amount" :disabled="selectedItem === null">
                            </div>
                        </div>
                    </div>

					<div class="form-group">
						<label for="itemIndexInput">Indeks proizvoda</label>
						<input id="itemIndexInput" class="form-control" type="number" placeholder="Index proizvoda" min="0" v-model="itemIndex" :disabled="selectedItem === null"/>
					</div>

                    <div class="form-group">
                        <label>Kategorije</label>
                        <b-form-select v-model="selectedCategory" :options="categories" :disabled="selectedItem === null">
                            <template #first>
                                <b-form-select-option :value="null" disabled>Odaberi kategoriju</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>

                    <div v-if="selectedCategory === 'CANDLE'" class="form-group">
                        <label>Mirisi</label>
                        <div v-if="isFetchingItemSmells" class="text-muted">
                            <small>Učitavanje mirisa...</small>
                        </div>
                        <b-form-select v-else v-model="selectedSmells" :options="smellOptions" multiple :disabled="selectedItem === null">
                            <template #first>
                                <b-form-select-option :value="null" disabled>Odaberi mirise</b-form-select-option>
                            </template>
                        </b-form-select>
                        <small class="form-text text-muted">Možete odabrati više mirisa za ovaj proizvod</small>
                    </div>

                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="availableInput" v-model="available" :disabled="selectedItem === null">
                            <label class="form-check-label" for="availableInput">Dostupan</label>
                        </div>
                    </div>

                    <button type="submit" class="btn btn-primary">Promeni</button>
                    <button type="button" @click="isPreviewActive = !isPreviewActive" class="btn btn-secondary">Pregledaj</button>
                </form>
            </div>
        </div>
        <div v-if="isPreviewActive" class="col-sm-4">
            <div class="card-body">
                <ShopItem :item="{ imageUrl, name, price, available, discount }" :preview="true"/>
            </div>
        </div>
    </div>
</template>

<script>
    import ShopItem from '@/component/user/shop/item/ShopItem'
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: 'AdminUpdateItem',
        components: {
            ShopItem
        },
        data() {
            return {
                name: '',
                description: '',
                imageUrl: '',
                width: 0,
                height: 0,
                thickness: 0,
                weight: 0,
                ingredients: '',
                price: 0,
                discount: 0,
                amount: 0,
				itemIndex: 0,
                available: true,
                isPreviewActive: false,
                selectedItem: null,
                selectedCategory: null,
                selectedSmells: []
            }
        },
        computed: {
            ...mapGetters([
                'isFetchingItems',
                'getItems',
                'getCategories',
                'isFetchingItemSmells',
                'getitemSmells'
            ]),

            items: {
                get() {
                    return this.getItems.map(item => {
                        return {
                            text: `${item.id} - ${item.name}`,
                            value: item
                        }
                    })
                }
            },

            categories: {
                get() {
                    return this.getCategories.map(category => {
                        let text = category
                        if (category === 'BODY')
                            text = 'Nega Tela'
                        else if (category === 'FACE')
                            text = 'Nega Lica'
                        else if (category === 'HAIR')
                            text = 'Nega Kose (nije dostupno)'
                        else if (category === 'GIFTBOX')
                            text = 'Poklon Kutija'
                        else if (category === 'CANDLE')
                            text = 'Sveće'

                        return {
                            text: text,
                            value: category
                        }
                    })
                }
            },

            smellOptions: {
                get() {
                    return this.getitemSmells.map(smell => ({
                        text: smell.name,
                        value: smell.id
                    }))
                }
            }
        },
        methods: {
            ...mapActions([
                'updateItem',
                'fetchAllItemSmells'
            ]),

            updateItemSubmit(e) {
                e.preventDefault()

                if (this.isFormValid()) {
                    const itemData = {
                        name: this.name,
                        description: this.description,
                        imageUrl: this.imageUrl,
                        width: parseFloat(this.width),
                        height: parseFloat(this.height),
                        thickness: parseFloat(this.thickness),
                        weight: parseFloat(this.weight),
                        ingredients: this.ingredients,
                        amountInStock: parseInt(this.amount),
                        price: parseFloat(this.price),
                        discount: parseFloat(this.discount),
                        itemIndex: parseInt(this.itemIndex),
                        available: this.available,
                        category: this.selectedCategory
                    }

                    if (this.selectedCategory === 'CANDLE' && this.selectedSmells.length > 0) {
                        itemData.smells = this.selectedSmells.map(smellId => {
                            return {
                                id: smellId
                            }
                        })
                    }

                    this.updateItem({
                        request: itemData,
                        existingId: this.selectedItem.id
                    })
                    this.clearState()
                }
            },

            isFormValid() {
                if (!this.name) {
                    this.$notify({
                        group: 'errors',
                        title: 'Greska u promeni proizvoda',
                        text: 'Ime ne moze da bude prazno!'
                    })
                    return false
                }

                if (this.selectedCategory === 'CANDLE' && (!this.selectedSmells || this.selectedSmells.length === 0)) {
                    this.$notify({
                        group: 'errors',
                        title: 'Greska u promeni proizvoda',
                        text: 'Sveće moraju imati bar jedan miris!'
                    })
                    return false
                }

                if (this.price === 0) {
                    this.$notify({
                        group: 'warn',
                        title: 'Upozorenje',
                        text: 'Cena proizvoda je postavljena na 0!'
                    })
                }

                return true
            },

            clearState() {
                this.name = ''
                this.imageUrl = ''
                this.description = ''
                this.width = 0
                this.height = 0
                this.thickness = 0
                this.weight = 0
                this.ingredients = ''
                this.price = 0
                this.discount = 0
                this.amount = 0
                this.available = true
                this.isPreviewActive = false
                this.selectedItem = null
				this.itemIndex = 0
                this.selectedCategory = null
                this.selectedSmells = []
            },

            onItemSelect() {
                this.name = this.selectedItem.name
                this.imageUrl = this.selectedItem.imageUrl
                this.description = this.selectedItem.description
                this.width = this.selectedItem.width
                this.height = this.selectedItem.height
                this.thickness = this.selectedItem.thickness
                this.weight = this.selectedItem.weight
                this.ingredients = this.selectedItem.ingredients
                this.price = this.selectedItem.price
                this.discount = this.selectedItem.discount
                this.amount = this.selectedItem.amountInStock
                this.available = this.selectedItem.available
				this.itemIndex = this.selectedItem.itemIndex
                this.selectedCategory = this.selectedItem.category
                
                // Handle smells - convert smell objects to IDs for the multi-select
                if (this.selectedItem.smells && Array.isArray(this.selectedItem.smells)) {
                    this.selectedSmells = this.selectedItem.smells.map(smell => 
                        typeof smell === 'object' ? smell.id : smell
                    )
                } else {
                    this.selectedSmells = []
                }
            }
        },
        mounted() {
            this.fetchAllItemSmells()
        },
        watch: {
            selectedCategory(newCategory, oldCategory) {
                if (oldCategory === 'CANDLE' && newCategory !== 'CANDLE') {
                    this.selectedSmells = []
                }
            }
        }
    }
</script>

<style scoped>
    .default-form button {
        width: 200px;
        margin-right: 10px;
        margin-bottom: 10px;
    }

    /* Smells dropdown styling */
    .form-group .form-text {
        font-size: 12px;
        color: #6c757d;
        margin-top: 4px;
    }

    .form-group .b-form-select {
        border: 1px solid #ced4da;
        border-radius: 4px;
    }

    .form-group .b-form-select:focus {
        border-color: #80bdff;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
</style>
